import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import PageHeading from "@/Components/PageHeading";
import { BriefcaseIcon } from "@heroicons/react/solid";
import { UploadIcon } from "@heroicons/react/outline";
import { Link } from "@inertiajs/inertia-react";

const Index = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Fee", route: route("fees") },
    ];

    const meta = [{ name: "Location", icon: BriefcaseIcon }];

    return (
        <div className="py-6">
            <PageHeading heading="Fees" breadcrumb={breadcrumb}>
                <span className="hidden sm:block">
                    <Link
                        href={route("fees.import")}
                        className="btn-base btn-light"
                    >
                        <UploadIcon
                            className="-ml-1 mr-2 h-5 w-5 text-gray-500"
                            aria-hidden="true"
                        />
                        Import
                    </Link>
                </span>
            </PageHeading>
            <div className="mt-8">
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-lg font-medium leading-6 text-gray-900">
                        Overview
                    </h2>
                    <dl className="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                            <dt className="truncate text-sm font-medium text-gray-500">
                                Title
                            </dt>
                            <dd className="mt-1 text-3xl font-semibold text-gray-900">
                                Stats
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    );
};

Index.layout = (page) => <Authenticated title={"Fee"} children={page} />;

export default Index;
